import React from 'react';
import Chip from '@material-ui/core/Chip';
import Button from "components/CustomButtons/Button.jsx";
import {
    Grid
} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import {appConstants} from "../../_constants";

const chipCommonStyle  = {
     margin: '5px',
    padding: '0 10px',
    borderRadius: '30px',
    color: '#fff'
};

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    chipPrimary: {
         ...chipCommonStyle,
         background: appConstants.INFO_COLOR,
        '&:hover': {
            background: appConstants.INFO_COLOR,
        },
        '&:focus': {
            background: appConstants.INFO_COLOR,
        }
    },
    chipSecondary: {
         ...chipCommonStyle,
         background: appConstants.REGIONAL_LIGHT_COLOR,
        '&:hover': {
            background: appConstants.REGIONAL_LIGHT_COLOR,
        },
        '&:focus': {
            background: appConstants.REGIONAL_LIGHT_COLOR,
        }
    },
    chipDefault: {
         ...chipCommonStyle,
         background: appConstants.WARNING_COLOR,
        '&:hover': {
            background: appConstants.WARNING_COLOR,
        },
        '&:focus': {
            background: appConstants.WARNING_COLOR,
        }
    },
});

const BillablePscPanel = (props) => {
    const { classes , handleOpenModal, billablePassengers} = props;
    return (
        <div>
            <Grid container spacing={24}>
            <Grid item md={8} sm={12} >
                {
                    billablePassengers.map((item, i) => { //get billablePassengers and loop the Chip component over them. Each of them should have a different color.
                        if (item.Description === "Adult")  {
                            return  <Chip
                                label={item.Description}
                                clickable
                                className={classes.chipSecondary}
                                key={i}
                            />
                        }
                        else if (item.Description === "Child") {
                            return  <Chip
                                label={item.Description}
                                clickable
                                color={"info"}
                                className={classes.chipPrimary}
                                key={i}
                            />
                        }
                        else {
                            return  <Chip
                                label={item.Description}
                                clickable
                                color={"secondary"}
                                className={classes.chipDefault}
                                key={i}
                            />
                        }
                    })
                }
            </Grid>
            <Grid item md={12} sm={12} className={'setBillable'}>
                {/*on click of Button, the modal should show */}
               <Button color={'regional'} onClick={handleOpenModal}>Set Billable Passenger</Button>
            </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(BillablePscPanel);


/* Written with love by Juliet April 2019 */



// WEBPACK FOOTER //
// ./src/Regional-Views/BillablePscSettings/BillablePscPanel.js